import { emptyImageRequest, ImageRequest } from "@/models/images/image.request"

export interface ImageItem extends ImageRequest {
    id: string
}

export const emptyImageItem: ImageItem = {
    ...emptyImageRequest,
    id: '',
}